export enum CashRegisterStateEnum {
  ACTIVE = 'active',
  DELETED = 'deleted',
  NOT_ACTIVE = 'not_active',
}
